import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

let state = {
  devices: [],
  totalInstalls: 0,
  usedInstalls: 0
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
